import * as React from 'react';
import { getTheme, Text } from 'office-ui-fabric-react';
import { ActionIconName } from '../Icons/action-icon';
import { SelectionMode } from '../List';
import { DetailsList } from '../List/DetailsList';
import { ListActionButton } from '../List/ListActionButton';
import { Tooltip } from '../Tooltip';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function BlobList(_ref) {
  let {
    items,
    path,
    disabled = false,
    onDelete,
    onSelect,
    showThumbnail,
    containerUrl,
    hideDelete = false
  } = _ref;
  const theme = getTheme();
  const deleteTooltipBody = /*#__PURE__*/_jsx(Text, {
    children: " Delete file"
  });
  const downloadTooltipBody = /*#__PURE__*/_jsx(Text, {
    children: "Download file"
  });
  const tableControlColumns = [{
    key: 'name',
    name: 'Filename',
    fieldName: 'Filename',
    minWidth: 100,
    isResizable: true,
    onRender: (item, _index, _column) => {
      if (item === undefined) return /*#__PURE__*/_jsx(_Fragment, {});
      return /*#__PURE__*/_jsx(_Fragment, {
        children: item.name.replace(path, '')
      });
    }
  }, {
    key: 'deleteButton',
    name: '',
    fieldName: 'deleteButton',
    minWidth: 50,
    maxWidth: 50,
    isResizable: false,
    onRender: (item, index, _column) => {
      if (item === undefined) return /*#__PURE__*/_jsx(_Fragment, {});
      return /*#__PURE__*/_jsx(Tooltip, {
        tooltipBody: deleteTooltipBody,
        children: /*#__PURE__*/_jsx(ListActionButton, {
          index: index,
          iconName: ActionIconName.Delete,
          onClick: () => {
            onDelete && onDelete(item.name);
          },
          iconColor: disabled ? theme.palette.neutralQuaternary : theme.palette.red,
          disabled: disabled
        })
      });
    }
  }, {
    key: 'downloadButton',
    name: '',
    fieldName: 'downloadButton',
    minWidth: 50,
    maxWidth: 50,
    isResizable: false,
    onRender: (item, index, _column) => {
      if (item === undefined) return /*#__PURE__*/_jsx(_Fragment, {});
      return /*#__PURE__*/_jsx(Tooltip, {
        tooltipBody: downloadTooltipBody,
        children: /*#__PURE__*/_jsx(ListActionButton, {
          index: index,
          iconName: ActionIconName.Download,
          onClick: () => {
            onSelect && onSelect(item.name);
          }
        })
      });
    }
  }];
  if (showThumbnail) {
    tableControlColumns.unshift({
      key: 'thumb',
      name: 'Preview',
      fieldName: 'Filename',
      minWidth: 20,
      maxWidth: 200,
      isResizable: true,
      onRender: (item, _index, _column) => {
        const imageServerUrl = 'wsrv.nl';
        if (item === undefined) return /*#__PURE__*/_jsx(_Fragment, {});
        const containerPath = containerUrl === null || containerUrl === void 0 ? void 0 : containerUrl.split('?')[0];
        const normalizedPath = containerPath !== null && containerPath !== void 0 && containerPath.endsWith('/') ? containerPath : "".concat(containerPath, "/");
        const imgurl = "https://".concat(imageServerUrl, "?url=").concat(normalizedPath).concat(encodeURIComponent(item.name), "&q=80&h=130");
        return /*#__PURE__*/_jsx("img", {
          loading: "lazy",
          src: imgurl
        });
      }
    });
  }
  if (hideDelete) {
    const filteredColumns = tableControlColumns.filter(column => column.key !== 'deleteButton');
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(DetailsList, {
        items: items,
        columns: filteredColumns,
        selectionMode: SelectionMode.none
      })
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(DetailsList, {
      items: items,
      columns: tableControlColumns,
      selectionMode: SelectionMode.none
    })
  });
}